(function () {
	'use strict';

	if (!customElements.get('pdp-recommendations')) {
		class PdpRecommendations extends HTMLElement {
			connectedCallback() {
				this.section = this.closest('.pdp-cross-sell');
				const observer = new IntersectionObserver(
					(entries, io) => {
						if (!entries[0].isIntersecting) return;
						io.unobserve(this);
						this.load(this.dataset.intent || 'related');
					},
					{ rootMargin: '0px 0px 400px 0px' }
				);
				observer.observe(this);
			}

			load(intent) {
				fetch(`${this.dataset.url}&intent=${intent}`)
					.then((response) => response.text())
					.then((text) => {
						const doc = new DOMParser().parseFromString(text, 'text/html');
						const recommendations = doc.querySelector('pdp-recommendations');

						if (recommendations && recommendations.querySelector('.pdp-card')) {
							this.innerHTML = recommendations.innerHTML;
							if (this.section) this.section.classList.add('pdp-cross-sell--loaded');
							document.dispatchEvent(new CustomEvent('swym:collections-loaded'));
						} else if (intent === 'complementary') {
							this.load('related');
						} else {
							this.hideSection();
						}
					})
					.catch((error) => {
						console.error(error);
						this.hideSection();
					});
			}

			hideSection() {
				if (this.section) this.section.hidden = true;
			}
		}
		customElements.define('pdp-recommendations', PdpRecommendations);
	}
})();
